var exports = {
  "G8": "whitepaperGrid__tZFuGc",
  "LJ": "whitepaperBreadcrumbLink__V3ypWB",
  "YX": "whitepaperHero__qgJyfC",
  "o0": "whitepaperRelatedCards__743u5D",
  "a7": "whitepaperHeroPrimaryButton__WR1DDA",
  "Jk": "whitepaperHeroImage__-5_xKL",
  "Mw": "formWrapper__dU1IuR",
  "O9": "ebookFormWrapperNoImage__prD93k",
  "qm": "ebookFormBox__KCMPRb",
  "K5": "hiddenOnMobile__6VkcyD",
  "wW": "TopicsBox__8V6JsB",
};

module.exports = exports;
